export enum Cookies {
    AuthToken = 'thkn92aETh3SpLrEWtVd',
}
